import { Component, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateComponent } from 'libs/shared/src/lib/component/ui/date-component/date-component.component';

@Component({
  standalone: false,
  selector: 'app-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: CustomDateComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: CustomDateComponent,
    },
  ],
})
export class CustomDateComponent extends DateComponent {
  constructor() {
    super();
  }
}
